import React, { ReactElement, useEffect, useRef, useState } from "react"
import { post, get } from "../../../netApi/fetch"

import { connect } from "react-redux"

import { Prompt } from "react-router-dom"
import { setLoginBindInfo } from "../../../reducers"

import BanUnLogin from "../../../high-component/BanUnLogin"
import Main from "../../../high-component/Content"
import { useHistory } from "react-router"
import styled from "styled-components"
import { confirm } from "../../Method/Confirm"
import imageUpload, { imageType } from "../../../methods/imageUpload"
import { Modal, Spin, message, Select } from "antd"
import { PlayCircleOutlined, PauseCircleOutlined, RightOutlined } from "@ant-design/icons"

// 定义类型
interface NoteType {
  id: string
  title: string
  content: string
  type: string
  image: string
  can_share: string
  show_read: string
  status: string
  createtime: string
  uid: string
  updatetime: string
  views: string
  comments: string
  reads: string
  sid: string
  images: string[]
}

interface NoteComponentProps {
  note?: NoteType
  history: ReturnType<typeof useHistory>
  setLoginBindInfo?: (data: any) => void
  user?: any
  loginBindInfo?: any
}

const TitleInput = styled.input`
  font-size: 24px;
  font-weight: bold;
  border: none;
  border-bottom: 2px solid #eee;
  padding: 10px 0;
  width: 100%;
  margin-bottom: 20px;

  &:focus {
    outline: none;
    border-bottom-color: var(--theme-main);
  }
`

const ContentTextarea = styled.textarea`
  width: 100%;
  min-height: 300px;
  /* border: 1px solid rgb(240, 240, 240); */
  border: none;
  resize: none;
  border-radius: 8px;
  /* padding: 15px; */
  font-size: 16px;
  line-height: 1.6;
  /* resize: vertical; */

  &:focus {
    outline: none;
    border-color: var(--theme-main);
  }
`

const CreationDate = styled.p`
  color: grey;
  font-size: 14px;
  margin-bottom: 15px;
`

const ImagesContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 10px;
  margin-bottom: 20px;
`

const ImageItem = styled.div`
  position: relative;
  border-radius: 8px;
  overflow: hidden;

  img {
    width: 120px;
    height: 120px;
    object-fit: cover;
    display: block;
  }

  .delete-image {
    position: absolute;
    top: 5px;
    right: 5px;
    background: rgba(255, 0, 0, 0.7);
    color: white;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-weight: bold;
  }
`

const ImageUploadButton = styled.label`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 2px dashed #ddd;
  border-radius: 8px;
  height: 120px;
  width: 120px;
  cursor: pointer;
  transition: border-color 0.3s;

  &:hover {
    border-color: var(--theme-main);
  }

  input {
    display: none;
  }
`

const ButtonGroup = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 20px;
`

const SaveButton = styled.button`
  background-color: #3498db;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;

  &:hover {
    background-color: #2980b9;
  }

  &:disabled {
    background-color: #95a5a6;
    cursor: not-allowed;
  }
`

const CancelButton = styled.button`
  background-color: #e74c3c;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;

  &:hover {
    background-color: #c0392b;
  }
`

const DeleteButton = styled.button`
  background-color: #e74c3c;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;

  &:hover {
    background-color: #c0392b;
  }
`

const RightPanel = styled.div`
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
`

const LoadingOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`

const LoadingSpinner = styled.div`
  width: 50px;
  height: 50px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid var(--theme-main, #3498db);
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`

// ===== styled 组件 =====
const ActionButton = styled.button`
  cursor: pointer;
  border-radius: 50vmin;
  background: var(--theme-main);
  color: #fff;
  padding: 8px 20px;
  font-size: 14px;
  border: none;
  font-weight: bold;
  &:hover {
    opacity: 0.8;
  }
`

const TextArea = styled.textarea`
  width: 100%;
  min-height: 400px;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 16px;
  font-size: 16px;
  line-height: 1.6;
  resize: vertical;
  outline: none;
`

const VideoList = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  margin-top: 12px;
  overflow-x: auto;
  overflow-y: hidden; /* 确保不出现垂直滚动条 */
  padding-bottom: 8px;
  scroll-behavior: smooth; /* 平滑滚动 */

  /* 确保滚动条样式 */
  &::-webkit-scrollbar {
    height: 6px;
  }
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }
  &::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 3px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #aaa;
  }
`

const VideoItem = styled.div`
  position: relative;
  width: 150px;
  flex-shrink: 0; /* 防止项目被压缩 */
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition:
    transform 0.3s,
    box-shadow 0.3s;
  cursor: pointer;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }
  &.selected::after {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.5);
    border-radius: 20px;
    z-index: 2;
    pointer-events: none;
  }
`

const LoadMoreButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 200px; /* 与视频高度一致 */
  flex-shrink: 0;
  border: 2px dashed #ddd;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.3s;
  background: #fafafa;

  &:hover {
    border-color: var(--theme-main);
    background: #f0f8ff;
    transform: translateY(-2px);
  }

  .load-more-icon {
    font-size: 24px;
    color: #666;
    transition: color 0.3s;
  }

  &:hover .load-more-icon {
    color: var(--theme-main);
  }
`

const VideoPlayer = styled.video`
  width: 100%;
  height: 200px;
  object-fit: cover;
  border-radius: 12px;
  background: #000;
`

const VideoInfo = styled.div`
  padding: 12px;
  background: #fff;
`

const VideoTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 4px;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

const VideoTime = styled.div`
  font-size: 12px;
  color: #999;
  margin-bottom: 8px;
`

// 音频列表样式
const SoundList = styled.div`
  display: flex;
  gap: 12px;
  overflow-x: auto;
  padding: 12px 0;
  max-height: 140px;
  
  /* 滚动条样式 */
  &::-webkit-scrollbar {
    height: 8px;
  }
  
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }
`

const SoundItem = styled.div`
  flex: 0 0 140px;
  border: 2px solid #e8e8e8;
  border-radius: 12px;
  background: #fff;
  cursor: pointer;
  transition: all 0.3s ease;
  overflow: hidden;
  
  &:hover {
    border-color: #d0d0d0;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
  
  &.selected {
    border-color: #1890ff;
    box-shadow: 0 4px 12px rgba(24, 144, 255, 0.2);
  }
`

const SoundInfo = styled.div`
  padding: 6px 8px;
  background: #fff;
`

const SoundTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 4px;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

const SoundTime = styled.div`
  font-size: 12px;
  color: #999;
  margin-bottom: 8px;
`

const SoundLoadMoreButton = styled.div`
  flex: 0 0 80px;
  height: 60px;
  border: 2px dashed #d0d0d0;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  color: #999;
  
  &:hover {
    border-color: #1890ff;
    color: #1890ff;
    
    .load-more-icon {
      transform: translateX(4px);
    }
  }
  
  .load-more-icon {
    font-size: 20px;
    transition: transform 0.3s ease;
  }
`

const ModalSection = styled.div`
  margin-bottom: 20px;
  text-align: left;
`

const GrayBox = styled.div`
  background: #f2f2f2;
  border-radius: 8px;
  padding: 16px;
  font-size: 14px;
  margin-top: 8px;
  max-width: 85%;
  min-width: 85%;
  float: left;
`

const ContentContainer = styled.div`
  margin-top: 40px;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
`

const LeftPanel = styled.div`
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`

// 全局加载蒙版
const GlobalLoadingOverlay = styled.div`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  backdrop-filter: blur(2px);
  border-radius: 12px;
`

const LoadingContent = styled.div`
  background: #fff;
  padding: 40px;
  border-radius: 16px;
  text-align: center;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  max-width: 400px;
  width: 90%;
`

const LoadingText = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin-bottom: 12px;
`

const LoadingSubText = styled.div`
  font-size: 14px;
  color: #666;
  margin-bottom: 24px;
  line-height: 1.5;
`

const _defaultState: NoteType = {
  id: "",
  title: "",
  content: "",
  type: "1",
  image: "",
  can_share: "0",
  show_read: "0",
  status: "1",
  createtime: "",
  uid: "",
  updatetime: "",
  views: "0",
  comments: "0",
  reads: "0",
  sid: "",
  images: [],
}

const NoteEdit = (props): ReactElement => {
  const [noteData, setNoteData] = useState<NoteType>(_defaultState)
  const [images, setImages] = useState<imageType[]>([])
  const [isSaving, setIsSaving] = useState(false)
  const [isChanged, setIsChanged] = useState(false)
  const [loading, setLoading] = useState(false)

  const pageId = props.match.params.id // -1 表示 新建
  const history = props.history
  // 地址栏参数
  const urlSearchParams = new URLSearchParams(props.location.search)
  const autoFocus = urlSearchParams.get("auto_focus") || ""
  const titleInputRef = useRef<HTMLInputElement>(null)
  const contentInputRef = useRef<HTMLTextAreaElement>(null)
  const imageInputRef = useRef<HTMLInputElement>(null)
  // const [urlSearchParamsImageDeleteId, setUrlSearchParamsImageDeleteId] = useState("")
  let urlSearchParamsImageDeleteId = ""
  useEffect(() => {
    switch (autoFocus) {
      case "title":
        titleInputRef.current?.focus()
        break
      case "content":
        contentInputRef.current?.focus()
        break
      case "image_delete":
        const id = urlSearchParams.get("id")
        if (!id) break
        // 只在第一次渲染的时候触发即可
        // eslint-disable-next-line react-hooks/exhaustive-deps
        urlSearchParamsImageDeleteId = id
        break
      case "image_add":
        imageInputRef.current?.click()
        break
      case "generatedVideo":
        saveAndGenerate()
        break
    }
    // 重定向路由，防止刷新的时候重复触发
    if (autoFocus) {
      history.replace(`/contentedit/${pageId}`)
    }
  }, [pageId])

  const [modalVisible, setModalVisible] = useState(false)

  // 声音模型
  const [soundText, setSoundText] = useState("")
  const [soundUrl, setSoundUrl] = useState("")
  const [soundId, setSoundId] = useState(null)
  const [isPlaying, setIsPlaying] = useState(false)
  const audioRef = React.useRef<HTMLAudioElement | null>(null)
  
  // 音频列表
  const [soundList, setSoundList] = useState<any[]>([])
  const [soundOffsetIndex, setSoundOffsetIndex] = useState(0)
  const [soundLength, setSoundLength] = useState(0)
  const [selectedSoundId, setSelectedSoundId] = useState<string | number | null>(null)
  const [soundLoading, setSoundLoading] = useState(false)
  const soundLimit = 5

  // 视频模型
  const [contentList, setContentList] = useState<any[]>([])
  const [viewOffsetIndex, setViewOffsetIndex] = useState(0)
  const [viewLength, setViewLength] = useState(0)
  const [selectedVideoId, setSelectedVideoId] = useState<string | number | null>(null)
  const [innerLoading, setInnerLoading] = useState(false)
  const limit = 5

  const [generating, setGenerating] = useState(false)
  const [generatedVideo, setGeneratedVideo] = useState<any>(null)
  const [playbackRate, setPlaybackRate] = useState(1.5)
  const videoRef = React.useRef<HTMLVideoElement>(null)

  // 获取音频列表
  const handleGetSoundList = (reset = false) => {
    // 只在首次加载时显示loading动画
    if (reset) setSoundLoading(true)
    const offset = reset ? 0 : soundOffsetIndex * soundLimit
    get(`/ip/viewmp3list?offset=${offset}&limit=${soundLimit}`, {}).then((res) => {
      console.log('ip/viewmp3list?offset :>> ', res);
      
      // 音频接口返回的是直接的数组，不像视频接口有 res.list 和 res.count
      const soundArray = Array.isArray(res) ? res : []
      
      if (reset) {
        setSoundList(soundArray)
        setSoundOffsetIndex(1)
        // 由于没有总数，我们假设如果返回数据少于limit，说明没有更多了
        setSoundLength(soundArray.length < soundLimit ? soundArray.length : soundArray.length + 1)
      } else {
        const newList = [...soundList, ...soundArray]
        setSoundList(newList)
        setSoundOffsetIndex(soundOffsetIndex + 1)
        // 更新总长度逻辑
        setSoundLength(soundArray.length < soundLimit ? newList.length : newList.length + 1)
      }
      
      if (soundArray.length > 0 && !selectedSoundId) {
        setSelectedSoundId(soundArray[0].id)
      }
      // 只在首次加载完成时关闭loading
      if (reset) setSoundLoading(false)
    })
  }

  const fetchSoundModel = () => {
    setSoundText("看着窗外缓缓下落的雨滴，滴答声成了最好的背景音乐，拿起笔，写下了心中的所思所想，雨天也有独特的韵味。")
    setSoundUrl("")
    // 改为获取音频列表
    handleGetSoundList(true)
    
    // 保持原有的单个音频获取（可能用于播放）
    get("/ip/viewmp3", {})
      .then((res) => {
        console.log("fetchSoundModel :>> ", res)
        setSoundUrl(res.url || "")
        setSoundId(res.id || null)
      })
      .catch(() => {
        setSoundText("音频加载失败")
        setSoundUrl("")
      })
  }
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" })
    fetchSoundModel()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  useEffect(() => {
    if (pageId === "-1") return
    setLoading(true)
    get("/content/view", { id: pageId })
      .then((res) => {
        setNoteData(res)
        setImages(res.images?.filter((image) => image.id !== urlSearchParamsImageDeleteId) || [])
        if (res.mp4) {
          setGeneratedVideo(res.mp4.url)
        }
      })
      .catch((err) => {
        if (err.code !== 0) {
          setModalVisible(false)
          confirm({ text: err.message || "获取笔记失败" }).then(() => {
            history.goBack()
          })
        }
      })
      .finally(() => {
        setLoading(false)
      })
  }, [pageId, urlSearchParamsImageDeleteId])

  const handleTitleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setNoteData({ ...noteData, title: e.target.value })
    setIsChanged(true)
  }

  const handleContentChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setNoteData({ ...noteData, content: e.target.value })
    setIsChanged(true)
  }

  const handleImageDelete = (id: string): void => {
    setImages((images) => images?.filter((image) => image.id !== id) || [])
    setIsChanged(true)
  }

  const handleImageUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    // if (e.target.files && e.target.files[0]) {
    //   const file = e.target.files[0]
    //   const reader = new FileReader()

    //   reader.onload = (event) => {
    //     if (event.target && typeof event.target.result === "string") {
    //       setImages([...images, event.target.result])
    //       setIsChanged(true)
    //     }
    //   }

    //   reader.readAsDataURL(file)
    // }
    for (let i = 0; i < e.target.files.length; i++) {
      const file = e.target.files[i]
      imageUpload(file, "content").then((res) => {
        console.log("res :>> ", res)
        setImages((lst) => [...lst, res])
        setIsChanged(true)
      })
    }
  }

  // 保存逻辑，isClick: true=仅保存，false=保存并生成视频
  const handleSave = async (isClick = true): Promise<boolean> => {
    if (!noteData.content.trim()) {
      confirm({ text: "请输入内容" })
      return false
    }
    if (isChanged === false) {
      if (isClick) confirm({ text: "没有任何修改，无需保存" })
      return !isClick // 用户点击保存时视为错误，自动保存时无更改不视为错误
    }
    setIsSaving(true)
    try {
      if (pageId === "-1") {
        // 新建
        const result = await post("/content/create?app=jieligo", {
          title: noteData.title,
          content: noteData.content,
          type: 1,
          image: images.map((i) => i.id).join(",") ?? "",
          imageids: images.map((i) => i.id),
        })
        setIsChanged(false)
        if (isClick) {
          confirm({ text: "保存成功" }).then(() => {
            history.replace(`/content/${result.id}`)
          })
        } else {
          // 保存并生成视频，跳转并带上 auto_focus
          history.replace(`/contentedit/${result.id}?auto_focus=generatedVideo`)
        }
        return true
      } else {
        // 编辑
        const updateData = {
          id: noteData.id,
          title: noteData.title,
          content: noteData.content,
          imageids: images.map((img) => img.id),
          sid: noteData.sid || "",
        }
        await post("/content/update", updateData)
        setIsChanged(false)
        if (isClick) {
          confirm({ text: "保存成功" }).then(() => {
            history.replace(`/content/${updateData.id}`)
          })
        }
        return true
      }
    } catch (error) {
      console.error("保存失败:", error)
      confirm({ text: "保存失败，请重试" })
      return false
    } finally {
      setIsSaving(false)
    }
  }

  const handleCancel = () => {
    // history.push(`/content/${pageId}`)
    history.goBack()
    // if (isChanged) {
    //   confirm({
    //     text: "确定要放弃修改吗？",
    //   }).then((res) => {
    //     if (res) {
    //       history.goBack()
    //     }
    //   })
    // } else {
    //   history.goBack()
    // }
  }

  const handleGetContentList = (reset = false) => {
    if (reset) setInnerLoading(true) // innerLoading 不是全屏加载
    const offset = reset ? 0 : viewOffsetIndex * limit
    get(`/ip/viewmp4list?offset=${offset}&limit=${limit}`, {}).then((res) => {
      setViewLength(res.count || 10)
      if (reset) {
        setContentList(res.list || [])
        setViewOffsetIndex(1)
      } else {
        setContentList([...contentList, ...(res.list || [])])
        setViewOffsetIndex(viewOffsetIndex + 1)
      }
      if (res.list.length > 0 && !selectedVideoId) {
        setSelectedVideoId(res.list[0].id)
      }
      if (reset) setInnerLoading(false)
    })
  }
  // 保存并生成视频
  const saveAndGenerate = async () => {
    if (isChanged) {
      // 有修改，先保存
      const result = await handleSave(false)
      if (!result) return
      // 新建时 handleSave 已经跳转并带 auto_focus=generatedVideo
      if (pageId === "-1") return
    }
    if (pageId === "-1" && !noteData.content.trim()) {
      confirm({ text: "请输入内容" })
      return
    }
    // 没有修改，或编辑保存后，弹出生成视频弹窗
    handleGetContentList(true)
    setModalVisible(true)
  }

  const handleDelete = () => {
    confirm({
      text: "确定要删除吗？",
    }).then((res) => {
      if (res) {
        post("/content/delete", { id: noteData.id }).then(() => {
          history.push("/")
        })
      }
    })
  }

  const togglePlay = () => {
    if (!audioRef.current || !soundUrl) return
    if (isPlaying) {
      audioRef.current.pause()
    } else {
      audioRef.current.play()
    }
    setIsPlaying(!isPlaying)
  }

  const handleGenerateVideo = async () => {
    // 前往 content 页面 发送请求，使用选中的音频ID
    const selectedSound = soundList.find(sound => sound.id === selectedSoundId)
    const selectedSoundUrl = selectedSound?.url || soundUrl
    
    history.replace(`/content/${noteData.id}?auto_focus=generatedVideo&contentid=${noteData.id}&videoid=${selectedVideoId}&soundid=${selectedSoundId}&soundurl=${encodeURIComponent(selectedSoundUrl)}`)
    // setGenerating(true)
    // // 生成视频接口增加 id 字段
    // post("/ip/createvideo", {
    //   contentid: noteData.id,
    //   soundUrl: selectedSoundUrl,
    //   videoId: selectedVideoId,
    //   soundId: selectedSoundId,
    // })
    //   .then((res) => {
    //     setGenerating(false)
    //     message.success("AI视频生成成功！")
    //     setGeneratedVideo(res.data.video_url)
    //     setModalVisible(false)
    //     if (props.match.params.id === noteData.id)
    //     history.replace(`/content/${res.data.contentid}`)
    //   })
    //   .catch((err) => {
    //     setGenerating(false)
    //     if (!err) err = "生成失败"
    //     message.error(err.data || err.message || err)
    //   })
  }

  // const isLogin = props.user?.uid
  // if (!isLogin) {
  //   alert("请先登入")
  //   return <Redirect to="/login" />
  // }
  // console.log("object :>> ", noteData.sid, props.user?.sid )
  // if (noteData.sid !== props.user?.sid) {
  //   alert("你没有编辑权限")
  //   props.history.goBack()
  //   return <></>
  // }
  return (
    <>
      {loading && (
        <LoadingOverlay>
          <LoadingSpinner />
        </LoadingOverlay>
      )}
      <div
        style={{
          maxWidth: "1120px",
          position: "relative",
          width: "100%",
          minWidth: "300px",
          margin: "0 auto",
          paddingTop: "90px",
          minHeight: "100vh",
          padding: "0 20px 40px",
          marginTop: "10px",
        }}
      >
        {/* 主要内容区域 - 使用flex布局 */}
        <div
          style={{
            display: "flex",
            gap: "20px",
            alignItems: "flex-start",
            flexDirection: window.innerWidth > 768 ? "row" : "column",
          }}
        >
          {/* 左侧主编辑区域 */}
          <div style={{ flex: 1, minWidth: 0 }}>
            <Prompt when={isChanged} message="您有未保存的修改，确定要离开吗？" />

            {/* 顶部导航栏 */}
            <div
              style={{
                position: "sticky",
                top: 0,
                left: 0,
                right: 0,
                height: "50px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "0 16px",
                zIndex: 10,
              }}
            >
              {/* 返回按钮 */}
              <div
                style={{
                  background: "#fff",
                  borderBottom: "1px solid #eee",
                  cursor: "pointer",
                  fontSize: "14px",
                  color: "#333",
                  padding: "10px 20px",
                  borderRadius: "50vmin",
                  fontWeight: "bold",
                }}
                onClick={() => handleCancel()}
              >
                返回上一页
              </div>

              {/* 中间标题 */}
              <div
                style={{
                  background: "#fff",
                  borderBottom: "1px solid #eee",
                  cursor: "pointer",
                  fontSize: "14px",
                  color: "#333",
                  padding: "10px 20px",
                  borderRadius: "50vmin",
                  fontWeight: "bold",
                }}
              >
                笔记编辑
              </div>

              {/* 右侧按钮 */}
              <div style={{ display: "flex", gap: "10px" }}>
                <button
                  onClick={() => handleDelete()}
                  style={{
                    backgroundColor: "#fff",
                    color: "#e74c3c",
                    border: "none",
                    padding: "10px 20px",
                    borderRadius: "50vmin",
                    fontSize: "14px",
                    cursor: "pointer",
                    fontWeight: "bold",
                  }}
                >
                  删除
                </button>
                <button
                  onClick={() => handleSave()}
                  disabled={isSaving}
                  style={{
                    backgroundColor: "#3ca7b5",
                    color: "#fff",
                    border: "none",
                    padding: "10px 20px",
                    borderRadius: "50vmin",
                    fontSize: "14px",
                    cursor: isSaving ? "not-allowed" : "pointer",
                    opacity: isSaving ? 0.6 : 1,
                    fontWeight: "bold",
                  }}
                >
                  {isSaving ? "保存中..." : "仅保存"}
                </button>
                <button
                  onClick={() => saveAndGenerate()}
                  disabled={generating}
                  style={{
                    backgroundColor: "#3ca7b5",
                    color: "#fff",
                    fontSize: "14px",
                    cursor: generating ? "not-allowed" : "pointer",
                    opacity: generating ? 0.6 : 1,
                    border: "none",
                    padding: "10px 20px",
                    borderRadius: "50vmin",
                    fontWeight: "bold",
                  }}
                >
                  {generating ? "生成中..." : "保存并生成视频"}
                </button>
              </div>
            </div>

            <div
              style={{
                padding: "20px 30px",
                marginTop: "20px",
                backgroundColor: "#fff",
                borderRadius: "20px",
              }}
            >
              <TitleInput placeholder="请输入标题" value={noteData.title} onChange={handleTitleChange} ref={titleInputRef} />

              <CreationDate>创建于：{noteData.createtime}</CreationDate>

              {/* <ImagesContainer className="images">
                {images.map((image, index) => (
                  <ImageItem key={index} className="image">
                    <img src={image.url} alt="" />
                    <span className="delete-image" onClick={() => handleImageDelete(image.id)}>
                      ×
                    </span>
                  </ImageItem>
                ))}

                <ImageUploadButton>
                  <i className="iconfont icon-plus" style={{ fontSize: "24px", marginBottom: "5px" }}></i>
                  <span>添加图片</span>
                  <input type="file" accept="image/*" onChange={handleImageUpload} ref={imageInputRef} />
                </ImageUploadButton>
              </ImagesContainer> */}

              <ContentTextarea placeholder="请输入内容..." value={noteData.content} onChange={handleContentChange} ref={contentInputRef} />

              {/* <ButtonGroup>
                <SaveButton onClick={handleSave} disabled={isSaving}>
                  {isSaving ? "保存中..." : "保存笔记"}
                </SaveButton>
                <CancelButton onClick={handleCancel}>取消</CancelButton>
                <DeleteButton onClick={handleDelete}>删除</DeleteButton>
              </ButtonGroup> */}
            </div>
          </div>

          {/* 右侧面板 */}
          <div
            style={{
              width: window.innerWidth > 768 ? "320px" : "100%",
              flexShrink: 0,
            }}
          >
            <RightPanel
              style={{
                marginTop: "70px",
                height: "fit-content",
                position: "sticky",
                top: "70px",
              }}
            >
              <h3>生成视频</h3>
              {/* 全局加载蒙版 */}
              {generatedVideo ? (
                <div>
                  <video
                    controls
                    ref={videoRef}
                    onLoadedMetadata={() => {
                      if (videoRef.current) {
                        videoRef.current.playbackRate = playbackRate
                      }
                    }}
                    style={{
                      width: "100%",
                      height: "320px",
                      objectFit: "cover",
                      borderRadius: "12px",
                      background: "#000",
                    }}
                  >
                    <source src={generatedVideo} />
                    您的浏览器不支持视频播放
                  </video>
                  {/* 播放速度选择器 */}
                  <div style={{ display: "flex", alignItems: "center", marginTop: "8px", marginBottom: "4px" }}>
                    <span style={{ marginRight: "8px", fontSize: "14px", color: "#666" }}>播放速度：</span>
                    <Select
                      value={playbackRate}
                      onChange={(value) => {
                        setPlaybackRate(value)
                        if (videoRef.current) {
                          videoRef.current.playbackRate = value
                        }
                      }}
                      style={{ width: 120 }}
                      size="small"
                    >
                      <Select.Option value={0.5}>0.5x</Select.Option>
                      <Select.Option value={0.75}>0.75x</Select.Option>
                      <Select.Option value={1}>1x</Select.Option>
                      <Select.Option value={1.25}>1.25x</Select.Option>
                      <Select.Option value={1.5}>1.5x</Select.Option>
                      <Select.Option value={1.75}>1.75x</Select.Option>
                      <Select.Option value={2}>2x</Select.Option>
                    </Select>
                  </div>
                  <button
                    onClick={() => {
                      const link = document.createElement("a")
                      link.href = generatedVideo
                      link.download = `video_${noteData.id}.mp4`
                      document.body.appendChild(link)
                      link.click()
                      document.body.removeChild(link)
                    }}
                    style={{
                      width: "100%",
                      marginTop: "12px",
                      padding: "10px 20px",
                      backgroundColor: "#fff",
                      color: "var(--theme-main)",
                      border: "1px solid var(--theme-main)",
                      borderRadius: "50vmin",
                      fontSize: "14px",
                      fontWeight: "500",
                      cursor: "pointer",
                      transition: "all 0.3s",
                    }}
                    onMouseEnter={(e) => {
                      const target = e.target as HTMLButtonElement
                      target.style.backgroundColor = "var(--theme-main)"
                      target.style.color = "#fff"
                    }}
                    onMouseLeave={(e) => {
                      const target = e.target as HTMLButtonElement
                      target.style.backgroundColor = "#fff"
                      target.style.color = "var(--theme-main)"
                    }}
                  >
                    下载视频
                  </button>
                </div>
              ) : (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100%",
                    minHeight: "260px",
                    color: "#666",
                    textAlign: "center",
                  }}
                >
                  <div
                    style={{
                      width: 80,
                      height: 80,
                      background: "#f2f6fa",
                      borderRadius: "16px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginBottom: 16,
                    }}
                  >
                    <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="48.000000" height="48.000000" fill="none">
                      <defs>
                        <image id="image_0" width="200.000000" height="200.000000" xlinkHref={require("../../../images/mp4Default.png")} />
                        <pattern id="pattern_0" width="1.000000" height="1.000000" image-fill-type="fill" patternContentUnits="objectBoundingBox">
                          <use transform="matrix(0.005,0,0,0.005,0,0)" xlinkHref="#image_0" />
                        </pattern>
                      </defs>
                      <rect id="ico-navigation-voiceover 1" width="200.000000" height="200.000000" x="0.000000" y="0.000000" fill="url(#pattern_0)" />
                    </svg>
                  </div>
                  <div style={{ fontSize: 16, fontWeight: 500, marginBottom: 8 }}>确认要表达的文字后</div>
                  <div style={{ fontSize: 14, color: "#999" }}>即可生成AI视频</div>
                </div>
              )}
            </RightPanel>
          </div>
        </div>

        {/* 弹窗 */}
        <Modal title="请确认模型" open={modalVisible} onCancel={() => setModalVisible(false)} footer={null} width={800}>
          <ModalSection>
            <h4>声音模型</h4>
            {soundLoading ? (
              <div style={{ height: 120, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Spin />
              </div>
            ) : (
              <SoundList
                onWheel={(e) => {
                  // 阻止默认的垂直滚动
                  e.preventDefault()
                  // 将垂直滚轮转换为横向滚动
                  const scrollContainer = e.currentTarget
                  scrollContainer.scrollLeft += e.deltaY
                }}
              >
                {soundList.map((item) => (
                  <SoundItem key={item.id} className={selectedSoundId === item.id ? "selected" : ""} onClick={() => setSelectedSoundId(item.id)}>
                    <SoundInfo>
                      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                        <div style={{ flex: 1, width: '93px' }}>
                          <SoundTitle>{item.filename || '音频文件'}</SoundTitle>
                          <SoundTime>{item.updatetime}</SoundTime>
                        </div>
                        <ActionButton
                          onClick={(e) => {
                            e.stopPropagation() // 防止触发选择
                            // 播放选中的音频
                            if (audioRef.current) {
                              if (isPlaying && audioRef.current.src === item.url) {
                                audioRef.current.pause()
                                setIsPlaying(false)
                              } else {
                                audioRef.current.src = item.url
                                audioRef.current.play()
                                setIsPlaying(true)
                              }
                            }
                          }}
                          style={{ 
                            padding: '4px 8px',
                            fontSize: '12px',
                            opacity: item.url ? 1 : 0.5, 
                            cursor: item.url ? "pointer" : "not-allowed" 
                          }}
                          disabled={!item.url}
                        >
                          {isPlaying && audioRef.current?.src === item.url ? <PauseCircleOutlined /> : <PlayCircleOutlined />}
                        </ActionButton>
                      </div>
                    </SoundInfo>
                  </SoundItem>
                ))}
                {soundList.length < soundLength && (
                  <SoundLoadMoreButton onClick={() => handleGetSoundList()}>
                    <RightOutlined className="load-more-icon" />
                  </SoundLoadMoreButton>
                )}
              </SoundList>
            )}
            <audio
              ref={audioRef}
              onEnded={() => setIsPlaying(false)}
              onError={() => {
                setIsPlaying(false)
              }}
            />
            {/* 隐藏原有的soundText显示 */}
            <div style={{ display: 'none' }}>
              <GrayBox>{soundText}</GrayBox>
            </div>
          </ModalSection>

          <ModalSection>
            <h4>视频模型</h4>
            {innerLoading ? (
              <Spin style={{ height: 270 }} />
            ) : (
              <VideoList
                onWheel={(e) => {
                  // 阻止默认的垂直滚动
                  e.preventDefault()
                  // 将垂直滚轮转换为横向滚动
                  const scrollContainer = e.currentTarget
                  scrollContainer.scrollLeft += e.deltaY
                }}
              >
                {contentList.map((item) => (
                  <VideoItem key={item.id} className={selectedVideoId === item.id ? "selected" : ""} onClick={() => setSelectedVideoId(item.id)}>
                    <VideoPlayer controls>
                      <source src={item.url} />
                      您的浏览器不支持视频播放
                    </VideoPlayer>
                    <VideoInfo>
                      <div style={{ float: "left" }}>
                        <VideoTitle>{item.filename}</VideoTitle>
                        <VideoTime>{item.updatetime}</VideoTime>
                      </div>
                    </VideoInfo>
                  </VideoItem>
                ))}
                {contentList.length < viewLength && (
                  <LoadMoreButton onClick={() => handleGetContentList()}>
                    <RightOutlined className="load-more-icon" />
                  </LoadMoreButton>
                )}
              </VideoList>
            )}
          </ModalSection>

          <div style={{ textAlign: "center" }}>
            <ActionButton
              onClick={() => {
                handleGenerateVideo()
                setModalVisible(false) // 生成后收起弹窗
              }}
              disabled={!selectedVideoId || !selectedSoundId || generating}
              style={{
                opacity: !selectedVideoId || !selectedSoundId || generating ? 0.5 : 1,
                cursor: !selectedVideoId || !selectedSoundId || generating ? "not-allowed" : "pointer",
              }}
            >
              {generating ? "生成中..." : "生成AI视频"}
            </ActionButton>
          </div>
        </Modal>
      </div>
    </>
  )
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setLoginBindInfo: (data) => {
      dispatch(setLoginBindInfo(data))
    },
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    user: state.login_user_data,
    loginBindInfo: state.loginBindInfo,
  }
}

export default BanUnLogin(Main(connect(mapStateToProps, mapDispatchToProps)(NoteEdit)))
